<template>
  <div class="form">
    <p>
      <small>
        Before changing the password we'll send you a one time code to verify
        ownership of your email address.
      </small>
    </p>
    <form-field type="email"
                label="Email"
                :validate="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i"
                :required="true"
                v-model="enteredEmail"
                :focus="true"
                @submit="submit">
    </form-field>
    <form-button color="blue"
                 pull="right"
                 @click="submit">
      Request code
    </form-button>
  </div>
</template>

<script>
import FormButton from '../elements/FormButton';
import FormField from '../elements/FormField';

export default {
  components: {
    FormButton,
    FormField,
  },

  data() {
    return {
      enteredEmail: this.email,
    };
  },

  props: {
    email: String,
  },

  methods: {
    submit: function submit() {
      if (this.enteredEmail) {
        this.$emit('submit', {
          email: this.enteredEmail,
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/RequestPasswordReset.vue